import React from "react";
import { useState } from "react";
import { RegisterationForm, LoginForm, ResetForm } from "./SignForms";
import * as constants from "../../utils/constants";
import "./modal.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import UserProfile from "./UserProfile";
import CloseIcon from '../../assets/images/close-icon.png';
import { useMediaQuery, useTheme, Button } from "@mui/material";
import LanguageSwitcher from "../LanguageSwitcher";

/**
 * Sign in modal
 * controlled by showSignUp state
 * @returns
 */
export default function SignModal({ classN, setShowModal }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const [righPaneActive, setRightPaneActive] = useState(false);
  const [formType, setformType] = useState(constants.LOGIN);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const user = JSON.parse(localStorage.getItem("user"));
  const isLogin = formType === constants.LOGIN;
  return (
    <div className={`${user && isMobile ? "mobile-wrapper" : "modal-overlay-wrapper"}`} dir="ltr">
      <div className="modal-overlay-background" onClick={() => setShowModal(false)} />
      <div className={`${classN}`}>
        <div style={{
            position: "absolute",
            left: "10px",
            top: "10px",
            // width: "200px",
            // height: "50px",
            fontSize: "16px",
            cursor: "pointer",
            zIndex: "10000"
          }} > <LanguageSwitcher stripe={true}/></div>
      
        {user ? <button
          className="admin-button"
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            width: "200px",
            height: "50px",
            fontSize: "16px",
            cursor: "pointer",
            zIndex: "10000"
          }}
        >
          {t('Sign.return')}
        </button> : <button
          className="admin-button"
          onClick={() => navigate("/")}
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            width: "200px",
            height: "50px",
            fontSize: "16px",
            cursor: "pointer",
            zIndex: "10000"
          }}
        >
        {t('Sign.return')}
        </button>}
        {!user && !isMobile ? (
          <div
            className={`modal modalcontainer ${righPaneActive ? "right-panel-active" : ""
              }`}
          >
            <div className="mform-container msign-up-container" dir={isArabic? 'rtl':'ltr'}>
              <RegisterationForm
                switchToLogin={() => setRightPaneActive(false)}
                setShowModal={setShowModal}
              />
            </div>
            <div className="mform-container msign-in-container" dir={isArabic? 'rtl':'ltr'}>
              <div className="flip-card-inner">
                <div
                  className='flip-card-front'
                  style={{
                    visibility: isLogin ? "visible" : "hidden",
                    opacity: isLogin ? 1 : 0,
                  }}
                >
                  <LoginForm
                    setformType={setformType}
                    setShowModal={setShowModal}
                    fade={formType !== constants.LOGIN}
                  />
                </div>
                <div
                  className='flip-card-back'
                  style={{
                    visibility: !isLogin ? "visible" : "hidden",
                    opacity: !isLogin ? 1 : 0,
                  }}
                >
                  <ResetForm
                    setformType={setformType}
                    fade={formType !== constants.PASS_RESET}
                  />
                </div>
              </div>
              {/* {formType === constants.PASS_RESET ? (
                <ResetForm setformType={setformType} />
              ) : (
                <LoginForm
                  setformType={setformType}
                  setShowModal={setShowModal}
                />
              )} */}
            </div>
            <div className="modal-overlay-container">
              <div className="overlay">
                <div className="overlay-panel overlay-left">
                  <h2 className="modal h2">{t("Sign.welcome_back")}</h2>
                  <p>{t("Sign.keep_connected")}</p>
                  <button
                    onClick={() => {
                      setRightPaneActive(false);
                      //toggle reset page if it's open
                      setformType(constants.LOGIN);
                    }}
                    className="ghost"
                    id="signIn"
                  >
                    {t("Sign.sign_in")}
                  </button>
                </div>
                <div className="overlay-panel overlay-right">
                  <h2 className="modal h2">{t("Sign.hello")}</h2>
                  <p>{t("Sign.enter_details")}</p>
                  <button
                    onClick={() => setRightPaneActive(true)}
                    className="ghost"
                    id="signUp"
                  >
                    {t("Sign.sign_up")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : !user && isMobile ? (
          <div style={{ textAlign: 'center', padding: '20px', display: "flex", flexDirection: "column", alignItems: "center", height: "80vh" }} dir={isArabic? 'rtl':'ltr'}>
            {/* <h2>{formType === constants.LOGIN ? t('Sign.sign_in') : t('Sign.sign_up')}</h2> */}
            {formType === constants.LOGIN ? (
              <div className="modal form">
                <LoginForm setformType={setformType} setShowModal={setShowModal} />
              </div>
            ) : formType === constants.PASS_RESET ? (
              <div className="modal form">
                <ResetForm
                  setformType={setformType}
                  fade={formType !== constants.PASS_RESET}
                />
              </div>
            ) : (
              <div className="modal form">
                <RegisterationForm switchToLogin={() => setformType(constants.LOGIN)} setShowModal={setShowModal} />
              </div>
            )}
            <div className="mobile-form-switcher">
              {formType === constants.LOGIN || formType === constants.PASS_RESET ? <div>
                <p className="modal h2">{t("Sign.hello")}</p>
                <p>{t("Sign.enter_details")}</p>
              </div> : <div>
                <p className="modal h2">{t("Sign.welcome_back")}</p>
                <p>{t("Sign.keep_connected")}</p>
              </div>}
              <Button
                onClick={() => setformType(formType === constants.LOGIN || formType === constants.PASS_RESET ? constants.REGISTER : constants.LOGIN)}
                variant="outlined"
                style={{ marginTop: '10px' }}
              >
                {formType === constants.LOGIN || formType === constants.PASS_RESET ? t('Sign.sign_up') : t('Sign.sign_in')}
              </Button>
            </div>
          </div>
        ) : (
          <div className="modal-overlay-wrapper" dir={isArabic? 'rtl':'ltr'} textAlign={isArabic? 'right':'left'}>
            <UserProfile />
          </div>
        )}
      </div>
    </div>
  );
}
